import axios from "axios";

const http = axios.create({
  baseURL: process.env.GATSBY_API_URL,
  headers: {
    Accept: "application/json",
  },
  proxy: {
    port: 4444,
  },
  maxContentLength: 1024 * 1024 * 20,
});

export const submitForm = (data) => {
  //send submitted Form API Integration
  return http.post("auth/pipedrive", data);
};
